import LegalLayout, { H2, P, UL } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      title="Terms of Service"
      description="The terms governing your use of MeasureTheRoof, including ordering, payment, refunds, and acceptable use."
      path="/terms"
      updated="June 17, 2026"
    >
      <P>
        These Terms of Service ("Terms") govern your access to and use of MeasureTheRoof (the
        "Service"). By creating an account or using the Service, you agree to these Terms. If you do
        not agree, do not use the Service.
      </P>

      <H2>1. The Service</H2>
      <P>
        MeasureTheRoof provides aerial roof measurement reports for properties in the United States.
        Reports are generated using third-party aerial imagery and measurement providers. Measurements
        are provided for estimating purposes; you are responsible for verifying measurements before
        ordering materials or submitting claims.
      </P>

      <H2>2. Accounts</H2>
      <UL>
        <li>You must provide accurate information and keep your credentials confidential.</li>
        <li>You are responsible for all activity under your account.</li>
        <li>You must be at least 18 years old and use the Service for business purposes.</li>
      </UL>

      <H2>3. Orders, Pricing & Payment</H2>
      <UL>
        <li>The exact price for each report is shown before you confirm an order. Prices are in U.S. dollars.</li>
        <li>You are charged at the time you place an order, not when the report completes.</li>
        <li>Payments are processed securely by Stripe. By placing an order you authorize the charge.</li>
        <li>We verify imagery coverage before payment; if coverage is unavailable, you will not be charged.</li>
      </UL>

      <H2>4. Refund Policy</H2>
      <UL>
        <li>Orders cancelled before the measurement provider begins processing are refundable.</li>
        <li>Completed reports are non-refundable, as the underlying measurement service has been performed.</li>
        <li>If a paid order cannot be fulfilled due to a provider error, we will issue a full refund.</li>
        <li>To request a refund, contact <a href="mailto:support@measuretheroof.com" className="text-orange font-semibold">support@measuretheroof.com</a>.</li>
      </UL>

      <H2>5. Acceptable Use</H2>
      <P>You agree not to:</P>
      <UL>
        <li>Use the Service for any unlawful purpose or to infringe others' rights.</li>
        <li>Reverse engineer, scrape, or resell the Service except as expressly permitted.</li>
        <li>Submit addresses or content you are not authorized to submit.</li>
        <li>Attempt to disrupt or compromise the Service's security or integrity.</li>
      </UL>

      <H2>6. Intellectual Property</H2>
      <P>
        The Service, including its software, design, and content, is owned by MeasureTheRoof and its
        licensors. Report data you purchase is licensed to you for your business use. Third-party
        imagery and measurement data remain subject to their providers' terms.
      </P>

      <H2>7. Disclaimers</H2>
      <P>
        THE SERVICE AND REPORTS ARE PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR
        IMPLIED, INCLUDING ACCURACY, MERCHANTABILITY, OR FITNESS FOR A PARTICULAR PURPOSE. You are
        responsible for independently verifying measurements before relying on them.
      </P>

      <H2>8. Limitation of Liability</H2>
      <P>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, MEASURETHEROOF WILL NOT BE LIABLE FOR ANY INDIRECT,
        INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR FOR LOST PROFITS OR DATA. OUR TOTAL
        LIABILITY FOR ANY CLAIM IS LIMITED TO THE AMOUNT YOU PAID FOR THE REPORT GIVING RISE TO THE CLAIM.
      </P>

      <H2>9. Indemnification</H2>
      <P>
        You agree to indemnify and hold harmless MeasureTheRoof from claims arising out of your use of
        the Service, your violation of these Terms, or your violation of any law or third-party right.
      </P>

      <H2>10. Termination</H2>
      <P>
        We may suspend or terminate your access for violation of these Terms. You may stop using the
        Service at any time. Sections that by their nature should survive termination will survive.
      </P>

      <H2>11. Governing Law</H2>
      <P>
        These Terms are governed by the laws of the United States and the State of Delaware, without
        regard to conflict-of-laws principles.
      </P>

      <H2>12. Changes</H2>
      <P>We may update these Terms. Continued use after changes become effective constitutes acceptance.</P>

      <H2>13. Contact</H2>
      <P>
        Questions? Contact{" "}
        <a href="mailto:support@measuretheroof.com" className="text-orange font-semibold">support@measuretheroof.com</a>.
      </P>
    </LegalLayout>
  );
}
